// extracted by mini-css-extract-plugin
module.exports = {"Errors":"UserBasicInfoSettings_Errors__zcxaO","profileImageController":"UserBasicInfoSettings_profileImageController__a4BWk"};